<template>
    <div>
        <div class="input-group color-picker flex" ref="colorpicker" style="width:100%">
            <span class="input-group-addon color-picker-container">
                <span class="current-color" :style="colorBox()" @click="togglePicker()"></span>
            </span>
            <div style="position:relative">
                <widget :value="colors" @input="updateFromPicker" v-show="displayPicker" />
            </div>
        </div>
    </div>
</template>

<script>
import { Sketch } from 'vue-color'

export default {
    components: {
        Widget: Sketch,
    },
    inheritAttrs: false,
    props: {
        color: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            colors: { hex: '#000000' },
            colorValue: '',
            displayPicker: false,
            defaultColor: '#000000'
        }
    },
    methods: {
        colorBox(){
            return `
                background-color: ${this.colorValue};
                border-radius: 4px;
            `;
        },
        setColor(color) {
            this.updateColors(color);
            this.colorValue = color;
        },
        updateColors(color) {
            if(color.slice(0, 1) === '#') {
                this.colors = {
                    hex: color
                };
            }
            else if(color.slice(0, 4) === 'rgba') {
                let rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                    hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                this.colors = {
                    hex: hex,
                    a: rgba[3],
                }
            }
        },

        showPicker() {
            document.addEventListener('click', this.documentClick);
            this.displayPicker = true;
        },
        hidePicker() {
            document.removeEventListener('click', this.documentClick);
            this.displayPicker = false;
        },
        togglePicker() {
            this.displayPicker ? this.hidePicker() : this.showPicker();
        },
        updateFromInput() {
            this.updateColors(this.colorValue);
        },
        updateFromPicker(color) {
            this.colors = color;
            if (color.rgba.a === 1) {
                this.colorValue = color.hex;
            }
            else {
                this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
            }
            //this.displayPicker = false;
        },
        documentClick(e) {

            let el = this.$refs.colorpicker;
            let target = e.target;
            if (el !== target && !el.contains(target)) {
                this.hidePicker()
            }
        }
    },
    watch: {
        colorValue(val) {
            if(val) {
                this.updateColors(val);
                this.$emit('input', val);
            }
        }
    },
    mounted() {
        this.setColor(this.color || this.defaultColor);
    }
}
</script>


<style>
    .vc-left{
        left: -39px;
    }
    .vc-right{
        right: 0;
    }
    .color-input{
        padding: .5rem;
        line-height: 1.5;
        display: block;
        width: 100%;
        border-width: 1px;
        color: #3d4852;
        background-color: #fff;
        border-radius: .25rem;
        text-align: left;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        position: relative;
    }
    .color-picker{
        position: relative;
        display: flex;
        width: 100%;
    }
    .vc-chrome,
    .vc-compact,
    .vc-sketch {
        position: absolute !important;
        bottom: 0;
        left: calc(100% + 5px);
        z-index: 9;
    }
    .current-color {
        display: inline-block;
        width: 40px;
        height: 40px;
        background-color: #000;
        cursor: pointer;
        border: 2px solid #E1E1E1;
    }
</style>
